import { useEffect, useState } from "react";

export const breakpoints = {
  mobile: "(max-width: 767px)",
  tablet: "(min-width: 768px) and (max-width: 1279px)",
  desktop: "(min-width: 1280px)",
};

const getBreakpoint = <T extends Record<string, string>>(breakpoints: T) => {
  return Object.keys(breakpoints).find((breakpoint) => window.matchMedia(breakpoints[breakpoint]).matches) as keyof T;
};

export const useDeviceBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState<keyof typeof breakpoints>("desktop");

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(getBreakpoint(breakpoints));
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    breakpoint,
  };
};
